import { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
const Input = forwardRef((props, ref) => {
  const {
    className,
    background,
    borderRadius,
    borderColor,
    color,
    fontSize,
    border,
    error,
    fontFamily,
    ...otherProps
  } = props;
  return (
    <>
      <input
        ref={ref}
        {...otherProps}
        className={classNames(
          "p-1 outline-0 w-full",
          className || "placeholder-medium-grey ",
          background || "bg-transparent",
          borderRadius || "rounded-none",
          color || "text-neutral-80",
          fontSize || "text-base",
          borderColor || "border-main-blue",
          border || "border-b",
          fontFamily || "font-subtitle"
        )}
      />
      <span className="text-xxs text-red-500 font-text">{error}</span>
    </>
  );
});
Input.displayName = "Input";
Input.propTypes = {
  background: PropTypes.string,
  borderRadius: PropTypes.string,
  borderColor: PropTypes.string,
  fontSize: PropTypes.string,
  className: PropTypes.string,
  border: PropTypes.string,
  color: PropTypes.string,
};

export default Input;
